import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Toast from "../../component/ToastService";
import { StatusType } from "../../constants/Status";
import { signup } from "./services/LoginService";
// import "./Signup.css"; // Import your custom CSS for styling
import { set_logged_data } from "../../service/Configuration";
import GoogleIcon from "@mui/icons-material/Google";
import { Box, Grid, Paper, Typography, TextField, Button, Link as MuiLink } from '@mui/material';

function Signup() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirm_password: "",
  });

  const onInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!formData.email) {
        Toast(StatusType.ERROR, "Please enter email address.");
        return;
      }

      if (!formData.password) {
        Toast(StatusType.ERROR, "Please enter password.");
        return;
      }

      if (!formData.confirm_password) {
        Toast(StatusType.ERROR, "Please enter confirm password.");
        return;
      }

      if (formData.password !== formData.confirm_password) {
        Toast(StatusType.ERROR, "Password and confirm password do not match.");
        return;
      }

      const response = await signup(formData);
      const responseData = await response.json();

      if (response.ok) {
        if (responseData) {
          set_logged_data(responseData.data.token);
          Toast(StatusType.SUCCESS, responseData.message);
          navigate("/app");
        }
      } else {
        if (responseData) {
          Toast(StatusType.ERROR, responseData.message);
        }
      }
    } catch (error) {
      Toast(StatusType.ERROR, error.message);
    }
  };

  return (
    <Grid container sx={{ height: '100vh' }}>
      
      {/* Left Section */}
      <Grid
        item
        md={6}
        sx={{
          display: { xs: 'none', md: 'flex' },
          justifyContent: 'center',
          alignItems: 'center',
          background: 'linear-gradient(135deg, rgba(60, 179, 113, 0.8), rgba(2, 2, 36, 0.8))',
        }}
      >
        <Box
          sx={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            padding: "16px 32px",
            borderRadius: "10px",
            color: "white",
          }}
        >
          <Typography variant="h4" align="center" color="white">
            Join US!
          </Typography>
        </Box>
      </Grid>

      {/* Right Section */}
      <Grid
        item
        xs={12}
        md={6}
        container
        justifyContent="center"
        alignItems="center"
      >
        <Paper
  elevation={0}
  sx={{
    p: 5,
    borderRadius: 4,
    width: 380,
    backdropFilter: 'blur(10px)',
    background: 'rgba(255, 255, 255, 0.85)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  }}
>
  <form onSubmit={onSubmit}>
    <Typography variant="h4" align="center" fontWeight={600} mb={3} color="primary.dark">
      Sign Up
    </Typography>

    {/* Email */}
    <TextField
      fullWidth
      margin="normal"
      label="Email Address"
      name="email"
      type="email"
      onChange={onInputChange}
      variant="outlined"
      InputProps={{ sx: { borderRadius: 2 } }}
    />

    {/* Password */}
    <TextField
      fullWidth
      margin="normal"
      label="Password"
      name="password"
      type="password"
      onChange={onInputChange}
      variant="outlined"
      InputProps={{ sx: { borderRadius: 2 } }}
    />

    {/* Confirm Password */}
    <TextField
      fullWidth
      margin="normal"
      label="Confirm Password"
      name="confirm_password"
      type="password"
      onChange={onInputChange}
      variant="outlined"
      InputProps={{ sx: { borderRadius: 2 } }}
    />

    {/* Submit Button */}
    <Button
      type="submit"
      fullWidth
      variant="contained"
      sx={{
        mt: 3,
        mb: 2,
        background: 'linear-gradient(135deg, #4A90E2, #357ABD)',
        borderRadius: 3,
        py: 1.5,
        fontWeight: 600,
        textTransform: 'none',
        boxShadow: '0px 4px 20px rgba(74, 144, 226, 0.3)',
        '&:hover': {
          background: 'linear-gradient(135deg, #357ABD, #2C5EA8)',
        },
      }}
    >
      Sign Up
    </Button>

    {/* OAuth Section */}
    <Box textAlign="center">
      <Typography variant="body2" mb={1} color="text.secondary">
        Or sign up with
      </Typography>
      <Button
        variant="outlined"
        startIcon={<GoogleIcon />}
        href={`${process.env.REACT_APP_BASE_PATH}/oauth2/authorization/google`}
        sx={{
          borderRadius: 3,
          textTransform: 'none',
          fontWeight: 500,
          color: '#444',
          borderColor: '#ccc',
          '&:hover': {
            backgroundColor: '#f9f9f9',
            borderColor: '#bbb',
          },
        }}
      >
        Continue with Google
      </Button>
    </Box>

    {/* Switch to login */}
    <Box mt={4} textAlign="center">
      <Typography variant="body2" color="text.secondary">
        Already a member?{' '}
        <MuiLink component={Link} to="/auth/login" underline="hover" color="primary">
          Login
        </MuiLink>
      </Typography>
    </Box>
  </form>
</Paper>

      </Grid>
    </Grid>
  );

}

export default Signup;
